import React, { Component, lazy } from 'react';
import classNames from 'classnames';
import { AppTopbar } from './AppTopbar';
import { AppFooter } from './AppFooter';
import { AppMenu } from './AppMenu';
import AppProfile from './AppProfile';
import { Route, withRouter } from 'react-router-dom';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import './layout/flags/flags.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import './layout/layout.scss';
import './App.scss';

import { ClientDashboard } from './components/ClientDashboard';
import { ClientPeopleCrud } from './components/ClientPeopleCrud';
import { ClientReportCrud } from './components/ClientReportCrud';
import { ClientTagCrud } from './components/ClientTagCrud';
import { ClientTagValueCrud } from './components/ClientTagValueCrud';


import { PeopleCrud } from './components/PeopleCrud';
import { ReportCrud } from './components/ReportCrud';
import { ClientCrud } from './components/ClientCrud';
import { ProfileCrud } from './components/ProfileCrud';
import { CSSTransition } from 'react-transition-group';
import { AppConfig } from './AppConfig';
//import PrimeReact from 'primereact/utils';


import { ProgressBar } from 'primereact/progressbar';
import { ProgressSpinner } from 'primereact/progressspinner';

import axios from 'axios';
import config from './config.json';
import { AuthorizationService, MANAGE_PEOPLE, MANAGE_REPORTS, MANAGE_CLIENTS, MANAGE_PROFILES, MANAGE_TAGS, MANAGE_CONFIGURATION } from './service/AuthorizationService';
import { ReportModal } from './components/ReportModal';
import { ReportService } from './service/ReportService';
import * as _ from 'lodash';
import { URLResolver } from './components/URLResolver';
import { LanguageService } from './service/LanguageService';
import { TagService } from './service/TagService';
import { ClientService } from './service/ClientService';
import { ConfigCrud } from './components/ConfigCrud';

import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { ContaAzulCallback } from './components/contaazul/ContaAzulCallback';

import ReactGA from 'react-ga';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

let expInterval = null;
const LOCAL_STORAGE_LOGGED_IN_USER_PROP = "loggedInUser";
const LOCAL_STORAGE_AUTHORIZATION_TOKEN_PROP = "AuthorizationToken";

console.log("version:", config.version);

axios.interceptors.request.use(function (req) {    
    if(req.url.startsWith(config.BASE_URL)){
        const token = localStorage.getItem(LOCAL_STORAGE_AUTHORIZATION_TOKEN_PROP);
        //console.log("request", req.url, token)
        req.headers['Authorization'] = token;
    }    
    return req;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    if(response.config.url.startsWith(config.BASE_URL)){
        const token = response.headers['pbiportal-authorization-token'];
        //console.log("response", response.config.url, token)
        if(token){
            localStorage.setItem(LOCAL_STORAGE_AUTHORIZATION_TOKEN_PROP, token);
        }
        else if(!response.config.url.endsWith('urlresolver')){
            localStorage.removeItem(LOCAL_STORAGE_AUTHORIZATION_TOKEN_PROP);
        }
    }
  return response;
}, function (error) {
    try {
        if(error.response && error.response.status === 401){
            const endpoint = error.response.config.url.split("/").reverse()[0];
            if(["login", "update-password"].indexOf(endpoint) < 0){
                clearInterval(expInterval);
                localStorage.removeItem("loggedInUser");
                alert("Sua sessão expirou. Por favor faça login novamente.")
                window.location.reload();
            }
        } 
    } catch (error) {
        console.log(error);
    }

    if(error && error.response && error.response.data && error.response.data.message)
    {
        return Promise.reject(error.response.data.message);
    }
    
    return Promise.reject(error);
});

class App extends Component {

    constructor() {
        super();
        this.state = {
            processing: true,
            authenticating: false,
            layoutMode: 'static',
            layoutColorMode: 'dark',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            inputStyle: 'outlined',
            rippleEffect: false,
            tags: []
            
        };
        //PrimeReact.ripple = false;

        this.onWrapperClick = this.onWrapperClick.bind(this);
        this.onToggleMenu = this.onToggleMenu.bind(this);
        this.onSidebarClick = this.onSidebarClick.bind(this);
        this.onMenuItemClick = this.onMenuItemClick.bind(this);
        this.onInputStyleChange = this.onInputStyleChange.bind(this);
        this.onRippleEffect = this.onRippleEffect.bind(this);
        this.onLayoutModeChange = this.onLayoutModeChange.bind(this);
        this.onColorModeChange = this.onColorModeChange.bind(this);
        this.languageService = new LanguageService();
    }

    componentWillMount() {
        this.unlisten = this.props.history.listen((location, action) => {
          ReactGA.pageview(window.location.pathname);
        });
      }
      componentWillUnmount() {
          this.unlisten();
      }

    onInputStyleChange(inputStyle) {
        this.setState({ inputStyle: inputStyle });
    }

    onRippleEffect(e) {
        //PrimeReact.ripple = e.value;
        this.setState({ rippleEffect: e.value })
    }

    onLayoutModeChange(mode) {
        this.setState({ layoutMode: mode });
    }

    onColorModeChange(mode) {
        this.setState({ layoutColorMode: mode });
    }

    onWrapperClick(event) {
        if (!this.menuClick) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            });
        }

        this.menuClick = false;
    }

    onToggleMenu(event) {
        this.menuClick = true;

        if (this.isDesktop()) {
            if (this.state.layoutMode === 'overlay') {
                this.setState({
                    overlayMenuActive: !this.state.overlayMenuActive
                });
            }
            else if (this.state.layoutMode === 'static') {
                this.setState({
                    staticMenuInactive: !this.state.staticMenuInactive
                });
            }
        }
        else {
            const mobileMenuActive = this.state.mobileMenuActive;
            this.setState({
                mobileMenuActive: !mobileMenuActive
            });
        }
        event.preventDefault();
    }

    onSidebarClick(event) {
        this.menuClick = true;
    }

    onMenuItemClick(event) {
        if (!event.item.items) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            })
        }
    }

    createMenu() {
        this.menu = [];
        const { modules } = this.state;
        
        this.authorizationService = new AuthorizationService();
        const loggedInUser = this.authorizationService.loggedInUser;
        
        if(loggedInUser.client)
        {
            this.menu.push({ label: this.languageService.getText('Dashboard'), icon: 'pi pi-fw pi-home', to: `${ loggedInUser.client && !loggedInUser.client.use_custom_url ? `/${loggedInUser.client.shortcode}` : '/'}` });
        };
        
        const managementItems = [];

        if(loggedInUser.client && this.authorizationService.hasPermission(MANAGE_CONFIGURATION)){
            managementItems.push({ label: this.languageService.getText('Configurations'), icon: 'pi pi-fw pi-cog', to: `${ loggedInUser.client && !loggedInUser.client.use_custom_url ? `/${loggedInUser.client.shortcode}` : ''}/config` });
        }

        if(this.authorizationService.hasPermission(MANAGE_PEOPLE)){
            managementItems.push({ label: this.languageService.getText('People'), icon: 'pi pi-fw pi-users', to: `${ loggedInUser.client && !loggedInUser.client.use_custom_url ? `/${loggedInUser.client.shortcode}` : ''}/people` });
        }

        if(this.authorizationService.getModules().find(m => m.id === 'REPORTS') && this.authorizationService.hasPermission(MANAGE_REPORTS)){
            managementItems.push({ label: this.languageService.getText('Reports'), icon: 'pi pi-fw pi-chart-line', to: `${ loggedInUser.client && !loggedInUser.client.use_custom_url ? `/${loggedInUser.client.shortcode}` : ''}/reports` });
        }

        if(!loggedInUser.client && this.authorizationService.hasPermission(MANAGE_CLIENTS)){
            managementItems.push({ label: this.languageService.getText('Clients'), icon: 'pi pi-fw pi-list', to: '/clients' });
        }

        if(!loggedInUser.client && this.authorizationService.hasPermission(MANAGE_PROFILES)){
            managementItems.push({ label: this.languageService.getText('Profiles'), icon: 'pi pi-fw pi-lock', to: '/profiles' });
        }

        if(loggedInUser.client && this.authorizationService.hasPermission(MANAGE_TAGS)){
            const tags = this.state.tags || [];
            for(let i = 0; i < tags.length; i++){
                managementItems.push({ label: tags[i].name, icon: 'pi pi-fw pi-list', to: `${ loggedInUser.client && !loggedInUser.client.use_custom_url ? `/${loggedInUser.client.shortcode}` : ''}/tags/${tags[i].id}` });
            }
        }

        modules.map(module => {
            const moduleMenu = (module.config.menus || {})["tenant_admin"];
            if(moduleMenu && Array.isArray(moduleMenu) && moduleMenu.length > 0){
                moduleMenu.forEach(item => {
                    if(module.config.features[item.feature] && this.authorizationService.hasPermission(item.permission)){
                        managementItems.push({ 
                            label: typeof item.label === "object" ? item.label[this.languageService.language] : item.label, 
                            icon: `pi pi-fw ${ item.icon || 'pi-bars'}`, 
                            to: `${(!loggedInUser.client || (loggedInUser.client && loggedInUser.client.use_custom_url)) ? '/' : `/${loggedInUser.client.shortcode}/`}${module.config.path}/${module.config.features[item.feature].path}` 
                        });
                    }
                });
            }
        })

        if(managementItems.length > 0){
            this.menu.push({ label: this.languageService.getText('Management'), icon: 'pi pi-fw pi-cog', items: managementItems});
        }

        // Reports Menu
        if(this.authorizationService.getModules().find(m => m.id === 'REPORTS') && loggedInUser.client && loggedInUser.reports){
            
            const reportsByGroups = _.groupBy(loggedInUser.reports, (a) => a.report_group || "root");

            const reportMenuItems = [];

            if((loggedInUser.favorites || []).length > 0){
                this.menu.push({ 
                    label: this.languageService.getText("Favorites"), 
                    icon: 'pi pi-fw pi-star', 
                    items: loggedInUser.reports.sort((a, b) => (a.config.order || 1000) > (b.config.order || 1000) ? 1 : -1)
                                .filter(report => loggedInUser.favorites.indexOf(report.id) >= 0)
                                .map(report => ({ label: report.name, report, icon: `pi pi-fw ${ report.has_access ? 'pi-file' : 'pi-lock' }`, command: this.openReportFromMenu }))
                });
            }

            // Root Reports
            if(reportsByGroups.root && reportsByGroups.root.length > 0){
                reportsByGroups.root.sort((a, b) => (a.config.order || 1000) > (b.config.order || 1000) ? 1 : -1).forEach(report => {
                    reportMenuItems.push({ label: report.name, report, icon: `pi pi-fw ${ report.has_access ? 'pi-file' : 'pi-lock' }`, command: this.openReportFromMenu });
                });    
            }


            let nonRootGroups = (Object.keys(reportsByGroups) || []).filter(l => l !== "root");
            const newHome = loggedInUser.client.config.newHome || false;
            if(newHome){
                nonRootGroups = nonRootGroups.sort((a, b) => a > b ? 1 : -1);
            }
            nonRootGroups.forEach(label => {
                const groupItems = [];
                reportsByGroups[label].sort((a, b) => (a.config.order || 1000) > (b.config.order || 1000) ? 1 : -1).forEach(report => {
                    groupItems.push({ label: report.name, report, icon: `pi pi-fw ${ report.has_access ? 'pi-file' : 'pi-lock' }`, command: this.openReportFromMenu });
                }); 
                this.menu.push({ label, icon: 'pi pi-fw pi-chart-line', items: groupItems});
            });

            if(reportMenuItems.length > 0){
                this.menu.push({ label: this.languageService.getText('Reports'), icon: 'pi pi-fw pi-chart-line', items: reportMenuItems});
            }
        }

        modules.map(module => {
            if(module.id !== "SUBSCRIPTION_PLANS" 
                || !loggedInUser.client 
                || (module.id === "SUBSCRIPTION_PLANS" && loggedInUser.client.config && loggedInUser.client.config.signature_plans_enabled))
            {
                const moduleMenu = (module.config.menus || {})[loggedInUser.client ? "tenant" : "main"];
                if(moduleMenu && Array.isArray(moduleMenu) && moduleMenu.length > 0){
                    const menu = { 
                        label: module.config.label ? typeof module.config.label === "object" ? module.config.label[this.languageService.language] : module.config.label: module.name, 
                        icon: `pi pi-fw ${ module.config.icon || 'pi-cog'}`, items: []};
                    moduleMenu.forEach(item => {
                        if(module.config.features[item.feature] && (this.authorizationService.hasPermission(item.permission) || !item.permission)){
                            menu.items.push({ 
                                label: typeof item.label === "object" ? item.label[this.languageService.language] : item.label, 
                                icon: `pi pi-fw ${ module.config.features[item.feature].icon ?? 'pi-bars' }`, 
                                to: `${(!loggedInUser.client || (loggedInUser.client && loggedInUser.client.use_custom_url)) ? '/' : `/${loggedInUser.client.shortcode}/`}${module.config.path}/${module.config.features[item.feature].path}` 
                            });
                        }
                    });
                    if(menu.items.length > 0){
                        this.menu.push(menu);
                    }
                }
            }
        })
    }

    openReportFromMenu = async (event) => {
        const report = event.item.report;
        try {
            const authService = new AuthorizationService();
            const reportService = new ReportService();
            const loggedInUser = await authService.getCurrentUser();
            const accessCheck = await reportService.checkAccess(loggedInUser.client, report);
            
            if(accessCheck.hasAccess){
                await this.setState({openingReport: true, report });

                
                const embedConfig = ((report.config.type || "PBI_EMBED") === "PBI_EMBED") ? await reportService.getEmbedConfig(this.state.loggedInUser.client, report) : null;

                
                const gaData = {
                    path: `${loggedInUser.client && !loggedInUser.client.use_custom_url ? `/${loggedInUser.client.shortcode}` : ''}/reports/${report.id}`,
                    title: `${loggedInUser.client ? loggedInUser.client.name + ' - ': ''}Relatórios - ${report.name}`
                }

                ReactGA.pageview(gaData.path, null, gaData.title);
                
                await this.setState({showReport: true, embedConfig, openingReport: false });
            }
            else {
                console.log(accessCheck);
                if(accessCheck.plans && accessCheck.plans.length > 0){
                    this.setState({ exclusiveContentPlan: accessCheck.plans[0], showExclusiveContentModal: true });
                }
            }
        } catch (error) {
            console.log(error);
            throw error;   
        }
    }

    addClass(element, className) {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    removeClass(element, className) {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    componentDidUpdate() {
        if (this.state.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    }

    isSidebarVisible() {
        if (this.isDesktop()) {
            if (this.state.layoutMode === 'static')
                return !this.state.staticMenuInactive;
            else if (this.state.layoutMode === 'overlay')
                return this.state.overlayMenuActive;
            else
                return true;
        }
        else {
            return true;
        }
    }

    async loadInitialData() {
        const initialData = {};
        const authorizationService = new AuthorizationService();
        if((authorizationService).hasPermission(MANAGE_TAGS)){
            const tagService = new TagService();
            initialData.tags = (await tagService.listAll()) || [];
        }
        //initialData.modules = ((await (new ModuleService()).listAll()) || {}).items || [];
        initialData.modules = authorizationService.getModules();

        initialData.modulesRoutes = []
        initialData.modules.forEach(module => {
            Object.keys(module.config.features || {}).forEach(featureName => {
                const feature = module.config.features[featureName];
                initialData.modulesRoutes.push({
                    path: `/${module.config.path}/${feature.path}`,
                    component: feature.component,
                    module: module.config.path
                })
            });
        });

        return initialData;
    }

    async componentDidMount() 
    {
        const clientService = new ClientService();
        
        try 
        {
            const loggedInUserLSObject = localStorage.getItem(LOCAL_STORAGE_LOGGED_IN_USER_PROP);
            let loggedInUser = loggedInUserLSObject && loggedInUserLSObject !== "" ? JSON.parse(loggedInUserLSObject) : null;
            
            if(loggedInUser)
            {
                // console.log(" We have a loggedInUser in the Local Storage. Checking token expiration...");
                // We have a loggedInUser in the Local Storage. Checking token expiration...
                try {
                    const updateLoggedInUser = (await axios.get(`${config.BASE_URL}check?withdata=1`)).data;
                    delete updateLoggedInUser.client;
                    // console.log("antes", loggedInUser);
                    loggedInUser = Object.assign(loggedInUser, updateLoggedInUser);
                    // console.log("depois", loggedInUser);

                    localStorage.setItem("loggedInUser", JSON.stringify(loggedInUser));
                    // Token ok!
                    const initialData = await this.loadInitialData();
                    await this.setState(Object.assign({ processing: false, loggedInUser, unauthorizedAccess: false, authenticationFailed: false }, initialData));
                    expInterval = setInterval(async () => { await axios.get(`${config.BASE_URL}check`) }, 60000)
                } catch (error) {
                    // Token has expired. Sending user to login screen
                    console.log(error);
                    localStorage.clear();
                    await this.setState({processing: false, loggedInUser: null, unauthorizedAccess: false, authenticationFailed: false})
                }
            }
            else {
                // console.log(" We don't have local storage user. Sending user to login screen");
                // We don't have local storage user. Sending user to login screen
                await this.setState({processing: false, loggedInUser: null, unauthorizedAccess: false, authenticationFailed: false})
            }
        } catch (error) {
            throw error;
        }
    }

    async onAuthenticated(loggedInUser){
        // console.log("depois do login", loggedInUser);
        localStorage.setItem("loggedInUser", JSON.stringify(loggedInUser));
        const initialData = await this.loadInitialData();
        await this.setState(Object.assign({ loggedInUser }, initialData));
        ReactGA.set({ userId: loggedInUser.id });
        expInterval = setInterval(async () => { await axios.get(`${config.BASE_URL}check`) }, 60000);
    }

    getModuleComponent(module, componentName){
        const component = require(`./modules/${module}/components/${componentName}`).default;
        return component;
    }

    render() {

        const { loggedInUser, processing, modulesRoutes, openingReport } = this.state;
        
        if(processing){
            return <div style={{width: '100%', height: '100%', display:'flex', alignItems:'center', justifyContent: 'center'}}>
                <ProgressSpinner strokeWidth="5"/>
            </div>
        }

        if(loggedInUser && loggedInUser.client && loggedInUser.client.custom_layout){
            const root = document.documentElement; 
            const customLayout = loggedInUser.client.custom_layout;
            if((customLayout.primaryBackgroundColor || "") !== ""){
                root.style.setProperty( "--menuBgColor", customLayout.primaryBackgroundColor); 
                root.style.setProperty( "--topBarBgColor", customLayout.primaryBackgroundColor);    
                root.style.setProperty( "--primaryButtonColor", customLayout.primaryButtonColor);    
            }

            if((customLayout.secondaryBackgroundColor || "") !== ""){
                root.style.setProperty( "--secondaryButtonColor", customLayout.secondaryBackgroundColor);    
            }

            if((customLayout.primaryFontColor || "") !== ""){
                root.style.setProperty( "--menuFontColor", customLayout.primaryFontColor); 
                
            }

            document.title = loggedInUser.client.name;
            document.getElementById("favicon").href = loggedInUser.client.custom_layout.favicon || "";
            
        }
        else {
            document.title = "";
            document.getElementById("favicon").href = ""
        }


        const logo = loggedInUser && loggedInUser.client ? loggedInUser.client.logo : 'assets/layout/images/logo.png';

        const wrapperClass = classNames('layout-wrapper', {
            'layout-overlay': this.state.layoutMode === 'overlay',
            'layout-static': this.state.layoutMode === 'static',
            'layout-static-sidebar-inactive': this.state.staticMenuInactive && this.state.layoutMode === 'static',
            'layout-overlay-sidebar-active': this.state.overlayMenuActive && this.state.layoutMode === 'overlay',
            'layout-mobile-sidebar-active': this.state.mobileMenuActive,
            'p-input-filled': this.state.inputStyle === 'filled',
            'p-ripple-disabled': this.state.rippleEffect === false
        });

        const sidebarClassName = classNames("layout-sidebar", {
            'layout-sidebar-dark': loggedInUser && loggedInUser.client ? true : false,
            'layout-sidebar-light': loggedInUser && loggedInUser.client ? false : true
        });

        if(loggedInUser){
            this.createMenu(loggedInUser);

            return (
                <>
                { openingReport && <div style={{position: 'absolute', zIndex: '1000', width: '100%', height: '100%', display:'flex', alignItems:'center', justifyContent: 'center'}}>
                        <ProgressSpinner strokeWidth="5"/>
                        </div>
                }
                <div className={wrapperClass} onClick={this.onWrapperClick}>
                    <AppTopbar onToggleMenu={this.onToggleMenu} />

                    <CSSTransition classNames="layout-sidebar" timeout={{ enter: 200, exit: 200 }} in={this.isSidebarVisible()} unmountOnExit>
                        <div ref={(el) => this.sidebar = el} className={sidebarClassName} style={{backgroundColor: loggedInUser.client ? loggedInUser.client.custom_layout.primaryBackgroundColor || '#F0F0F0' : '#F0F0F0'}} onClick={this.onSidebarClick}>
                            <div className="layout-logo">
                                <img alt="Logo" src={logo} style={{width: '200px'}} />
                            </div>
                            <AppProfile />
                            <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                        </div>
                    </CSSTransition>

                    { this.state.showExclusiveContentModal &&
                        <Dialog 
                                    visible={true} 
                                    style={{ width: '50vw' }} 
                                    header={<div style={{padding: '20px', fontSize: '24px'}}>Conteúdo Exclusivo</div>}
                                    modal 
                                    className="p-fluid" 
                                    footer={<>
                                        <Button label={"Assinar"} className="p-button-text" 
                                            style={{ fontSize: '28px', color: '#fff', backgroundColor: loggedInUser.client.custom_layout.primaryButtonColor, borderColor: loggedInUser.client.custom_layout.primaryButtonColor}}
                                            onClick={() => {
                                            this.props.history.push(`${loggedInUser.client && !loggedInUser.client.use_custom_url ? `/${loggedInUser.client.shortcode}` : ''}/subscriptions/plans?p=${ this.state.exclusiveContentPlan.id }`)
                                            this.setState({ exclusiveContentPlan: null, showExclusiveContentModal: false });
                                        }} />
                                        <Button label={"Não, obrigado"} className="p-button-text" onClick={() => this.setState({ showExclusiveContentModal: false })} />
                                    </>} 
                                    onHide={() => this.setState({ showExclusiveContentModal: false })}>
                                    <div style={{padding: '20px', fontSize: '24px'}}>Para acessar este conteúdo você precisa ser assinante do plano <b>{ this.state.exclusiveContentPlan.name }</b>.</div>
                        </Dialog>
                    }

                    { loggedInUser.client && 
                        <div className="layout-main">
                            <Route path={loggedInUser.client.use_custom_url ? "/" : "/:shortcode/"} exact render={(arg) => <ClientDashboard client={loggedInUser.client}/>} />
                            <Route path={loggedInUser.client.use_custom_url ? "/planshome" : "/:shortcode/planshome"} exact render={(arg) => <ClientDashboard client={loggedInUser.client} force={true}/>} />
                            <Route path={loggedInUser.client.use_custom_url ? "/people" : "/:shortcode/people"} render={(arg) => <ClientPeopleCrud client={loggedInUser.client}/>} />
                            <Route path={loggedInUser.client.use_custom_url ? "/reports" : "/:shortcode/reports"}  render={(arg) => <ClientReportCrud client={loggedInUser.client}/>} />
                            <Route path={loggedInUser.client.use_custom_url ? "/tags/:id" : "/:shortcode/tags/:id"}  render={(arg) => <ClientTagValueCrud client={loggedInUser.client} match={arg.match}/>} />
                            <Route path={loggedInUser.client.use_custom_url ? "/tags" : "/:shortcode/tags"} exact render={(arg) => <ClientTagCrud client={loggedInUser.client}/>} />
                            <Route path={loggedInUser.client.use_custom_url ? "/config" : "/:shortcode/config"} exact render={(arg) => <ConfigCrud client={loggedInUser.client}/>} />
                            <Route path={loggedInUser.client.use_custom_url ? "/returnContaAzul" : "/:shortcode/returnContaAzul"} exact render={(arg) => <ContaAzulCallback client={loggedInUser.client}/>} />
                            { modulesRoutes.map((route,i) => <Route key={`route_${i}`} path={(loggedInUser.client.use_custom_url ? "" : "/:shortcode") + route.path} exact component={this.getModuleComponent(route.module, route.component)} />)}
                        </div>
                    }

                    { !loggedInUser.client &&
                        <div className="layout-main">
                            <Route path="/" exact component={ReportCrud} /> 
                            <Route path="/people" component={PeopleCrud} />
                            <Route path="/reports" component={ReportCrud} />
                            <Route path="/clients" component={ClientCrud} />
                            <Route path="/profiles" component={ProfileCrud} />
                            { modulesRoutes.map((route,i) => <Route key={`route_${i}`} path={route.path} exact component={this.getModuleComponent(route.module, route.component)} />)}
                            
                        </div>
                    }

                    { this.state.showReport &&
                        <ReportModal report={this.state.report} embedConfig={this.state.embedConfig} onHide={() => this.setState({showReport: false})}/>
                    }

                    <AppFooter />
                    
                    

                    <div className="layout-mask"></div>
                </div>
                </>
            );
        }
    
        return <URLResolver onAuthenticated={this.onAuthenticated.bind(this)}/>
    }
}

export default withRouter(App);
